// extracted by mini-css-extract-plugin
module.exports = {"container":"_slug__container__HbDSt"};